import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import Wrapper from './Styles';

const propTypes = {
  label: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  tooltip: PropTypes.string,
  testId: PropTypes.string,
  fontSize: PropTypes.string,
  onClick: PropTypes.func
};

const defaultProps = {
  label: undefined,
  color: undefined,
  icon: 'TR5-Copy_to_clipboard',
  iconColor: undefined,
  tooltip: 'Copy to clipboard',
  testId: 'copy-to-clip-board',
  fontSize: undefined,
  onClick: undefined
};

const CopyToClipboard = ({
  label,
  color,
  icon,
  iconColor,
  tooltip,
  testId,
  fontSize,
  onClick,
  className,
  children
}) => {
  return (
    <Wrapper
      fontSize={fontSize}
      color={color}
      data-testid={testId}
      onClick={onClick}
      className={className}
    >
      {label}
      <Icon icon={icon} color={iconColor} tooltip={tooltip} />
      {children}
    </Wrapper>
  );
};

CopyToClipboard.propTypes = propTypes;
CopyToClipboard.defaultProps = defaultProps;

export default CopyToClipboard;
